const state = {
  timeConfirm: 60,
  orderType: 'buy'
};

const getters = {
  timeConfirm: state => {
    return state.timeConfirm;
  },
  orderType: state => {
    return state.orderType;
  }
};

const mutations = {
  changeTimeConfirm: (state, newItem) => {
    state.timeConfirm = newItem;
  },
  changeOrderType: (state, newTypeOrder) => {
    state.orderType = newTypeOrder;
  }
};

export default {
  state,
  getters,
  mutations
};



//////////////////
// WEBPACK FOOTER
// ./store/modules/general.js
// module id = null
// module chunks = 